import { render, staticRenderFns } from "./MockManagementPanel.vue?vue&type=template&id=282f0c30&scoped=true&"
import script from "./MockManagementPanel.vue?vue&type=script&lang=js&"
export * from "./MockManagementPanel.vue?vue&type=script&lang=js&"
import style0 from "./MockManagementPanel.vue?vue&type=style&index=0&id=282f0c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f0c30",
  null
  
)

export default component.exports